import { useEffect } from "react";
import axiosBaseURL from "../../common/apis/axiosBaseURL";


const OrderRequest = () => {
  
useEffect(async()=>{
    // const params = new URLSearchParams(window.location.search) // id=123
    // let userid = params.get('userid');
    // let email = params.get('email');
    // let phone = params.get('phone');
    // let amount = params.get('amount');
    
    // if(userid && email && phone && amount){
    
    // let orderId="CRE"+(new Date()*1)+userid;
    // const response = await axiosBaseURL.post(`/app/${apiVersion.v1}/payment/createOrderInTrans`, 
    // {userid:userid ,amount: amount,order_id:orderId, currency: "INR" })
    //     // .then(response => response.json())
    //     .then((response) => {
    //         return response
    //     })
    //     .catch(error => {
            
    //         return error
    //     })

    // function post(path, params, method='post') {

    //     // The rest of this code assumes you are not using a library.
    //     // It can be made less verbose if you use one.
    //     const form = document.createElement('form');
    //     form.method = method;
    //     form.action = path;
      
    //     for (const key in params) {
    //       if (params.hasOwnProperty(key)) {
    //         const hiddenField = document.createElement('input');
    //         hiddenField.type = 'hidden';
    //         hiddenField.name = key;
    //         hiddenField.value = params[key];
      
    //         form.appendChild(hiddenField);
    //       }
    //     }
      
    //     document.body.appendChild(form);
    //     form.submit();
    //   }
      
    //   post('https://phpapi.credexon.com/TrnPayRequest.php', {
    //     'OrderNo': orderId,
    //     'EmailId': email,
    //     'MobileNo': phone,
    //     'TotalAmount': amount,
    //     'CurrencyName': "INR",
    //     'CustomerName': email
    //   });    
    // }
        
})
    return (
        <>
           {/* <form method="post" name="payment" action="https://phpapi.credexon.com/TrnPayRequest.php">
         <input type="hidden" name="OrderNo" value={"ORD"+(new Date()*1)} />
     <input type="hidden" name="EmailId" value="tanuj@gmail.com" />
             <input type="hidden" name="MobileNo" value="9632587569" />
             <input type="hidden" name="TotalAmount" value={value.amount} />
             <input type="hidden" name="CurrencyName" value="INR" />
             <input type="hidden" name="CustomerName" value="tanuj@gmail.com" />
     </form>
     <script language="javascript">document.payment.submit();</script> */}
        </>
    );
};

export default OrderRequest;
